import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import axis from "../../Assets/Projects/Logo_Axis_Bank.png";
import vinayamFront from "../../Assets/Projects/vinayam_academics.png";
import vinayamBack from "../../Assets/Projects/vinayam_academics_back.png";
import avssHrm from "../../Assets/Projects/avss_hrm.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vinayamFront}
              isBlog={false}
              title="Vinayam Academics Frontend"
              description="Our coaching institute website, developed using Angular, provides a seamless and dynamic user experience for students, educators, and administrators. It is designed to facilitate access to course materials, schedules, and essential resources, while also allowing users to stay connected and engaged with the institute."
              ghLink="https://github.com/RishabhRocko/vinayam_frontend"
              demoLink="https://vinayamclasses.in/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vinayamBack}
              isBlog={false}
              title="Vinayam Academics Frontend"
              description="Our coaching institute website, developed using Angular, provides a seamless and dynamic user experience for students, educators, and administrators. It is designed to facilitate access to course materials, schedules, and essential resources, while also allowing users to stay connected and engaged with the institute."
              ghLink="https://github.com/RishabhRocko/vinayam_backend"
              demoLink="https://vinayamclasses.in/VGC/admin"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={avssHrm}
              isBlog={false}
              title="AVSS HRM"
              description="The HRM (Human Resource Management) website developed using Core PHP is designed to streamline and automate various HR functions, making it easier for HR professionals to manage employee-related tasks efficiently. The website offers a comprehensive suite of features to handle recruitment, employee records, attendance, payroll, and performance management."
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={axis}
              isBlog={false}
              title="NRI Axis Bank"
              description="The NRI account opening project for Axis Bank, developed using Mezzio, aims to provide a seamless and efficient process for Non-Resident Indians (NRIs) to open and manage their accounts. The project leverages the capabilities of Mezzio to ensure a robust, scalable, and secure platform."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={axis}
              isBlog={false}
              title="Forex Card Axis Bank"
              description="The Forex Card project for Axis Bank, developed using Mezzio, aims to provide a convenient and secure method for managing foreign currency while traveling internationally. The project leverages the capabilities of Mezzio to ensure a robust, scalable, and user-friendly platform."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={axis}
              isBlog={false}
              title="BBPS Axis Bank"
              description="The Bharat Bill Payment System (BBPS) project for Axis Bank, developed using Mezzio, aims to provide a unified and efficient platform for bill payments. The project leverages the capabilities of Mezzio to ensure a robust, scalable, and user-friendly system that simplifies the bill payment process for customers and billers alike."
            />
          </Col>

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
